import { FormSendAnswerFeedback } from "components/form/FormSendAnswerFeedback";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import { useConfirmDialogExit } from "hooks";
import { useSnackbar } from "providers/SnackbarProvider";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { reportAnswer } from "services";
import { useAppDispatch } from "store/store";
import {
  modalSendFeedbackTitle,
  modalSendFeedbackSubTitle,
  formSendFeedback,
  buttonSend,
  snackbarSummaryFeedbackSentSuccessTitle,
  snackbarSummaryFeedbackSentSuccessSubTitle,
} from "_constants";
import {
  setActionAnswer,
  updateChatAnswerFeedback,
} from "store/slicer/GestioneChatSlice";
import { setCheckOpenedReportLoadStatus } from "store/slicer/CheckOpenedReportSlice";

export const ModalSendAnswerFeedback = ({
  showModal,
  projectId,
  answerId,
  questionId,
  closeModalSendFeedbackCallback,
}: {
  showModal: boolean;
  projectId: string;
  answerId: string;
  questionId: string;
  closeModalSendFeedbackCallback: Function;
}) => {
  const dispatch = useAppDispatch();
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogExit } = useConfirmDialogExit();

  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      projectId: projectId,
      answerId: answerId,
      description: "",
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  useEffect(() => {
    setValue("projectId", projectId);
    setValue("answerId", answerId);
  }, [answerId, projectId, setValue]);

  const onSubmit = (formData: any) => {
    reportAnswer(formData)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarSummaryFeedbackSentSuccessTitle,
          detail: snackbarSummaryFeedbackSentSuccessSubTitle,
          life: 5000,
        });
        dispatch(updateChatAnswerFeedback({ questionId: questionId } as any));
        dispatch(
          setActionAnswer({
            idQuestion: questionId,
            idAnswer: answerId,
            hasFeedback: true,
          })
        );
        dispatch(setCheckOpenedReportLoadStatus(false));
        resetFormState();
      })
      .catch((_) => {});
  };

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    closeModalSendFeedbackCallback();
    control._reset();
  };

  return (
    <SingleStepDialog
      onHideCallback={handleDismiss}
      height="323px"
      width="700px"
      header={
        <SingleStepHeaders
          title={modalSendFeedbackTitle}
          subtitle={modalSendFeedbackSubTitle}
        />
      }
      body={
        <SingleStepBody
          content={
            <form
              id={formSendFeedback}
              onSubmit={handleSubmit(onSubmit)}
              className="width-100"
            >
              <FormSendAnswerFeedback control={control} />
            </form>
          }
        />
      }
      footer={
        <SingleStepFooter
          dismiss={handleDismiss}
          form={formSendFeedback}
          labelSubmit={buttonSend}
        />
      }
      display={showModal}
      setVisible={() => {}}
    />
  );
};
